/*
* @Author: tengmaoqing
* @Date:   2018-05-14 19:49:34
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-05-23 14:53:32
*/
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import parse from 'url-parse';

const cache = setupCache({
  maxAge: 15 * 60 * 1000,
  key: req => {
    const urlObj = parse(req.url, true);
    const query = urlObj.query;
    delete query.timestamp;
    delete query.sign;
    const queryStr = Object.keys(query).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`).join('&');
    return `${urlObj.origin}${urlObj.pathname}?${queryStr}`;
  },
  // debug: true,
  exclude: {
    query: false
  }
});

const createInstance = (param) => {
  let options = {
    headers: {
      // 'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
      // 'Group-Header': '1'
      // 'withCredentials': true
    },
    timeout: 10000
    // validateStatus (status) {
    //   // 异常状态处理
    //   return status >= 200 && status < 300; // default
    // },
    // transformRequest: [(data) => {
    //   if (typeof FormData !== 'undefined' && data instanceof FormData) {
    //     return data;
    //   }
    //   return qs.stringify(data);
    // }],
  };

  const addThrottle = (instance) => {
    const pending = new Map();
    const addPending = (config) => {
      const urlObj = parse(config.url, true);
      // if (!['1385', '1595', '1439'].includes(urlObj.query.pid)) {
      //   return;
      // }
      const url = urlObj.pathname;
      config.cancelToken = config.cancelToken || new axios.CancelToken(cancel => {
        if (!pending.has(url)) { // 如果 pending 中不存在当前请求，则添加进去
          pending.set(url, cancel);
        }
      });
    };
    const removePending = (config) => {
      const urlObj = parse(config.url, true);
      // if (!['1385', '1595', '1439'].includes(urlObj.query.pid)) {
      //   return;
      // }
      const url = urlObj.pathname;
      if (pending.has(url)) { // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
        const cancel = pending.get(url);
        cancel(url);
        pending.delete(url);
      }
    };

    instance.interceptors.request.use(config => {
      removePending(config);
      addPending(config);
      return config;
    });
    instance.interceptors.response.use(response => {
      removePending(response.config);
      return response;
    });
  };

  if (typeof window !== 'undefined') {
    options.adapter = cache.adapter;
  }

  options = Object.assign({}, options, param);

  // if (options.method === 'POST') {
  //   options.data = qs.stringify(config.data);
  //   options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  // }
  const httpInstances = axios.create(options);

  httpInstances.cache = cache;

  if (typeof window !== 'undefined') {
    addThrottle(httpInstances);
  }

  return httpInstances;
};

export default createInstance;
